import { baseApi } from '../../../core/baseApi';
import { 
  createListQuery,
  createCreateMutation,
  createDeleteMutation
} from '../../../patterns/crud';
import { TeamMember, InviteUserRequest, InviteUserResponse } from '../types';

// Organization Members API - provides access to organization members for all authenticated users
// Uses /organization-members endpoint which is accessible to all users (not admin-only like /users)
export const organizationsMembersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get all members in the current user's organization (authentication required, no admin permissions needed)
    getOrganizationMembers: createListQuery<TeamMember>('/organization-members', 'TeamMembers')(builder),
    inviteTeamMember: createCreateMutation<InviteUserResponse, InviteUserRequest>('/users/invite', 'TeamMembers')(builder),
    resendInvitation: builder.mutation<InviteUserResponse, string>({
      query: (userId) => ({
        url: `/users/${userId}/resend-invitation`,
        method: 'POST',
      }),
      invalidatesTags: [{ type: 'TeamMembers', id: 'LIST' }],
    }),
    deleteOrganizationMember: createDeleteMutation('/users', 'TeamMembers')(builder),
  }),
  overrideExisting: true,
});

export const {
  useGetOrganizationMembersQuery,
  useInviteTeamMemberMutation,
  useResendInvitationMutation,
  useDeleteOrganizationMemberMutation,
} = organizationsMembersApi;